// extracted by mini-css-extract-plugin
module.exports = {"container":"ArticleRecommendation_container__NE1Bg","title":"ArticleRecommendation_title__Pkh41","articles":"ArticleRecommendation_articles___UxMV"};